import React from 'react';

const DashboardLayout = ({ children }) => {
    const bgImage = "url('https://images.unsplash.com/photo-1690967809748-e9aec554880a?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')";

    return (
        <div
            className="app-container"
            style={{
                backgroundImage: bgImage,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundAttachment: 'fixed',
                minHeight: "100%",
                width: "100%"
            }}
        >
            <div
                style={{
                    position: 'absolute',
                    inset: 0,
                    background: 'rgba(251, 238, 210, 0.85)',
                    backdropFilter: 'blur(3px)',
                    zIndex: 1
                }}
            />

            <div className="content-wrapper" style={{ position: "relative", zIndex: 2 }}>
                {children}
            </div>
        </div>
    );
};

export default DashboardLayout;
